/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AddLetterSeenBy } from '@coin/shared/core/util-models-v2';
import { AutoFinalizeLetters } from '@coin/shared/core/util-models-v2';
import { AutoFinalizeLettersByQuery } from '@coin/shared/core/util-models-v2';
import { AutoForwardLetters } from '@coin/shared/core/util-models-v2';
import { CommunicationsLettersLetter } from '@coin/shared/core/util-models-v2';
import { ConfirmLetter } from '@coin/shared/core/util-models-v2';
import { CreateDryLetterBatch } from '@coin/shared/core/util-models-v2';
import { CreateLabel } from '@coin/shared/core/util-models-v2';
import { CreateLetter } from '@coin/shared/core/util-models-v2';
import { CreateLetterBatch } from '@coin/shared/core/util-models-v2';
import { CreateLetterBulk } from '@coin/shared/core/util-models-v2';
import { CreateLetterComment } from '@coin/shared/core/util-models-v2';
import { CreateMail } from '@coin/shared/core/util-models-v2';
import { CreateNotification } from '@coin/shared/core/util-models-v2';
import { CreateTask } from '@coin/shared/core/util-models-v2';
import { CreateWorkflowInstanceComment } from '@coin/shared/core/util-models-v2';
import { CreateWorkflowTemplate } from '@coin/shared/core/util-models-v2';
import { DeleteLetterList } from '@coin/shared/core/util-models-v2';
import { DownloadLetters } from '@coin/shared/core/util-models-v2';
import { EmailBatch } from '@coin/shared/core/util-models-v2';
import { EmailDetail } from '@coin/shared/core/util-models-v2';
import { ForwardLetter } from '@coin/shared/core/util-models-v2';
import { Label } from '@coin/shared/core/util-models-v2';
import { LetterBatchMetadataModel } from '@coin/shared/core/util-models-v2';
import { LetterComment } from '@coin/shared/core/util-models-v2';
import { LetterTemplatesCreateTemplate } from '@coin/shared/core/util-models-v2';
import { Mail } from '@coin/shared/core/util-models-v2';
import { MailsRemoveManyLabels } from '@coin/shared/core/util-models-v2';
import { Notification } from '@coin/shared/core/util-models-v2';
import { NotificationsRemoveManyLabels } from '@coin/shared/core/util-models-v2';
import { NotificationsUpdatePopulation } from '@coin/shared/core/util-models-v2';
import { PageOfCommunication } from '@coin/shared/core/util-models-v2';
import { PageOfEmailBatch } from '@coin/shared/core/util-models-v2';
import { PageOfEmailPreview } from '@coin/shared/core/util-models-v2';
import { PageOfPresetLetterPublicationInfo } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PageOfWorkflow } from '@coin/shared/core/util-models-v2';
import { PageOfWorkflowTemplate } from '@coin/shared/core/util-models-v2';
import { PublishLetter } from '@coin/shared/core/util-models-v2';
import { PublishLetterBatch } from '@coin/shared/core/util-models-v2';
import { PublishLetterList } from '@coin/shared/core/util-models-v2';
import { PublishPresetLetterBatch } from '@coin/shared/core/util-models-v2';
import { PublishPresetLetterList } from '@coin/shared/core/util-models-v2';
import { RejectLetter } from '@coin/shared/core/util-models-v2';
import { RemoveManyTaskLabels } from '@coin/shared/core/util-models-v2';
import { RepublishLetterBatch } from '@coin/shared/core/util-models-v2';
import { SetPresetLetterPublicationInfo } from '@coin/shared/core/util-models-v2';
import { SetPresetLetterPublicationInfoBatch } from '@coin/shared/core/util-models-v2';
import { SetPresetLetterPublicationInfoList } from '@coin/shared/core/util-models-v2';
import { SignLetter } from '@coin/shared/core/util-models-v2';
import { Task } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfLetterBatchMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPublishingMetadata } from '@coin/shared/core/util-models-v2';
import { UnpublishLetter } from '@coin/shared/core/util-models-v2';
import { UnpublishLetterBatch } from '@coin/shared/core/util-models-v2';
import { UnpublishLetterList } from '@coin/shared/core/util-models-v2';
import { UpdateLetter } from '@coin/shared/core/util-models-v2';
import { UpdateMailMessage } from '@coin/shared/core/util-models-v2';
import { UpdateMailPopulation } from '@coin/shared/core/util-models-v2';
import { UpdateMailQueueBatch } from '@coin/shared/core/util-models-v2';
import { UpdateMailQueueEmail } from '@coin/shared/core/util-models-v2';
import { UpdateMailSettings } from '@coin/shared/core/util-models-v2';
import { UpdateNotificationMessage } from '@coin/shared/core/util-models-v2';
import { UpdateNotificationSettings } from '@coin/shared/core/util-models-v2';
import { UpdateTask } from '@coin/shared/core/util-models-v2';
import { UpdateTaskContent } from '@coin/shared/core/util-models-v2';
import { UpdateTaskPopulation } from '@coin/shared/core/util-models-v2';
import { UpdateTaskSettings } from '@coin/shared/core/util-models-v2';
import { UpdateTaskTargetGroup } from '@coin/shared/core/util-models-v2';
import { UpdateTemplate } from '@coin/shared/core/util-models-v2';
import { UpdateWorkflow } from '@coin/shared/core/util-models-v2';
import { UpdateWorkflowTemplate } from '@coin/shared/core/util-models-v2';
import { Workflow } from '@coin/shared/core/util-models-v2';
import { WorkflowInstanceComment } from '@coin/shared/core/util-models-v2';
import { WorkflowTemplate } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface AddRuleSetMailsParams {
  id: string;
  updateMailPopulation?: UpdateMailPopulation;
}

export interface AddRuleSetNotificationsParams {
  id: string;
  notificationsUpdatePopulation?: NotificationsUpdatePopulation;
}

export interface AddRuleSetTasksParams {
  id: string;
  updateTaskPopulation?: UpdateTaskPopulation;
}

export interface ArchiveLetterTemplatesParams {
  id: string;
}

export interface ArchiveMailsParams {
  id: string;
}

export interface ArchiveNotificationsParams {
  id: string;
}

export interface ArchiveTaskTasksParams {
  id: string;
}

export interface AutoForwardLettersLetterAutoForwardParams {
  autoForwardLetters?: AutoForwardLetters;
}

export interface CommunicationsAutoFinalizeLettersByQueryLetterFinalizationParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  autoFinalizeLettersByQuery?: AutoFinalizeLettersByQuery;
}

export interface CommunicationsAutoFinalizeLettersLetterFinalizationParams {
  autoFinalizeLetters?: AutoFinalizeLetters;
}

export interface CommunicationsBatchDownloadByQueryLettersParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  downloadLetters?: DownloadLetters;
}

export interface CommunicationsBatchUnpublishLetterLetterPublicationsParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  unpublishLetterBatch?: UnpublishLetterBatch;
}

export interface CommunicationsCreateLetterBatchLettersParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  createLetterBatch?: CreateLetterBatch;
}

export interface CommunicationsCreateLettersParams {
  createLetter?: CreateLetter;
}

export interface CommunicationsCreateMailsParams {
  createMail?: CreateMail;
}

export interface CommunicationsCreateManyLettersParams {
  createLetterBulk?: CreateLetterBulk;
}

export interface CommunicationsListUnpublishLetterLetterPublicationsParams {
  unpublishLetterList?: UnpublishLetterList;
}

export interface CommunicationsPublishLetterBatchLetterPublicationsParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  publishLetterBatch?: PublishLetterBatch;
}

export interface CommunicationsPublishLetterListLetterPublicationsParams {
  publishLetterList?: PublishLetterList;
}

export interface CommunicationsQueryLetterTemplatesParams {
  queryTitle?: string;
  queryDescription?: string;
  queryLetterType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  queryState?: 'Created' | 'Published' | 'Archived';
  queryCreatedBy?: string;
  queryUpdatedBy?: string;
  queryCreatedAt?: string;
  queryUpdatedAt?: string;
  queryCreatedAtFrom?: string;
  queryCreatedAtTo?: string;
  queryUpdatedAtFrom?: string;
  queryUpdatedAtTo?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface CreateLabelsParams {
  createLabel?: CreateLabel;
}

export interface CreateLetterBatchDryLettersParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  createDryLetterBatch?: CreateDryLetterBatch;
}

export interface CreateLetterCommentsParams {
  letterId: string;
  createLetterComment?: CreateLetterComment;
}

export interface CreateLetterTemplatesParams {
  letterTemplatesCreateTemplate?: LetterTemplatesCreateTemplate;
}

export interface CreateNotificationsParams {
  createNotification?: CreateNotification;
}

export interface CreateTasksParams {
  createTask?: CreateTask;
}

export interface CreateWorkflowInstanceCommentsParams {
  workflowInstanceId: string;
  createWorkflowInstanceComment?: CreateWorkflowInstanceComment;
}

export interface CreateWorkflowTemplatesParams {
  createWorkflowTemplate?: CreateWorkflowTemplate;
}

export interface DeleteLetterTemplatesParams {
  id: string;
}

export interface DeleteManyBySeasonLettersParams {
  seasonId: string;
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId2?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
}

export interface DeleteManyLettersParams {
  deleteLetterList?: DeleteLetterList;
}

export interface DeleteWorkflowTemplatesParams {
  id: string;
}

export interface ForwardLetterActionsParams {
  letterId: string;
  forwardLetter?: ForwardLetter;
}

export interface GetDetailsMailQueueParams {
  id: number;
}

export interface GetLabelsParams {
  id: string;
}

export interface GetLetterTemplatesParams {
  id: string;
}

export interface GetLettersParams {
  id: string;
}

export interface GetMailsParams {
  id: string;
}

export interface GetNotificationsParams {
  id: string;
}

export interface GetPresetLetterPublicationInfoLetterPublicationsParams {
  seasonId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  page?: number;
  size?: number;
}

export interface GetTasksParams {
  id: string;
}

export interface GetTasksByEmployeeIdTasksParams {
  employeeId: string;
}

export interface GetWorkflowTemplatesParams {
  id: string;
}

export interface PublishLetterActionsParams {
  letterId: string;
  confirmLetter?: ConfirmLetter;
}

export interface PublishLetterLetterPublicationsParams {
  id: string;
  publishLetter?: PublishLetter;
}

export interface PublishMailsParams {
  id: string;
}

export interface PublishNotificationsParams {
  id: string;
}

export interface PublishPresetLetterBatchLetterPublicationsParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  publishPresetLetterBatch?: PublishPresetLetterBatch;
}

export interface PublishPresetLetterListLetterPublicationsParams {
  publishPresetLetterList?: PublishPresetLetterList;
}

export interface PublishTaskTasksParams {
  id: string;
}

export interface QueryBatchesMailQueueParams {
  author?: string;
  subject?: string;
  authorGid?: string;
  recipient?: string;
  sender?: string;
  status?: 'Created' | 'Sending' | 'Sent' | 'Canceled';
  type?: 'General' | 'Merit' | 'Incentive';
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface QueryByEmployeeLettersParams {
  employeeId: string;
}

export interface QueryByWorkflowWorkflowTemplatesParams {
  workflowId: string;
  type?:
    | 'Letter'
    | 'EmployeeTask'
    | 'EmployeeMail'
    | 'ManagerTask'
    | 'ManagerMail'
    | 'BusinessPartnerMail'
    | 'ECLMail'
    | 'ManagerPromotionMail'
    | 'BusinessPartnerTask'
    | 'CompanyManagerMail'
    | 'GlobalEquityTeamMail';
  state?: 'Created' | 'Published' | 'Archived';
  page?: number;
  size?: number;
}

export interface QueryCommunicationsParams {
  querySeasonId?: string;
  queryLanguage?: string;
  queryTitle?: string;
  queryDescription?: string;
  queryState?: Array<'Draft' | 'Published' | 'Archived'>;
  queryType?: Array<string>;
  queryLabel?: Array<string>;
  queryFirstname?: string;
  queryLastname?: string;
  queryFullname?: string;
  queryPublicationDate?: string;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  pagingPage?: number;
  pagingSize?: number;
}

export interface QueryFieldValuesCommunicationsParams {
  pageablePage?: number;
  pageableSize?: number;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  seasonId?: string;
  language?: string;
  title?: string;
  description?: string;
  state?: string;
  type?: string;
  firstname?: string;
  lastname?: string;
  label?: string;
}

export interface QueryLabelsParams {
  name?: string;
}

export interface QueryLetterCommentsParams {
  letterId: string;
}

export interface QueryLettersParams {
  receiverId?: string;
  managerId?: string;
  businessPartnerId?: string;
  seasonId?: string;
  isAdmin?: boolean;
}

export interface QueryMailsByBatchIdMailQueueParams {
  batchId: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  author?: string;
  subject?: string;
  authorGid?: string;
  recipient?: string;
  sender?: string;
  status?: 'Created' | 'Sending' | 'Sent' | 'Canceled';
  type?: 'General' | 'Merit' | 'Incentive';
}

export interface QueryWorkflowInstanceCommentsParams {
  workflowInstanceId: string;
}

export interface QueryWorkflowTemplatesParams {
  type?:
    | 'Letter'
    | 'EmployeeTask'
    | 'EmployeeMail'
    | 'ManagerTask'
    | 'ManagerMail'
    | 'BusinessPartnerMail'
    | 'ECLMail'
    | 'ManagerPromotionMail'
    | 'BusinessPartnerTask'
    | 'CompanyManagerMail'
    | 'GlobalEquityTeamMail';
  state?: 'Created' | 'Published' | 'Archived';
  page?: number;
  size?: number;
}

export interface QueryWorkflowsParams {
  category?: 'Standard' | 'Allocation' | 'MeritLetter' | 'Achievement';
  page?: number;
  size?: number;
}

export interface RejectLetterActionsParams {
  letterId: string;
  rejectLetter?: RejectLetter;
}

export interface RemoveLabelsMailsParams {
  id: string;
  mailsRemoveManyLabels?: MailsRemoveManyLabels;
}

export interface RemoveLabelsNotificationsParams {
  id: string;
  notificationsRemoveManyLabels?: NotificationsRemoveManyLabels;
}

export interface RemoveLabelsTasksParams {
  id: string;
  removeManyTaskLabels?: RemoveManyTaskLabels;
}

export interface RepublishLetterBatchLetterPublicationsParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  republishLetterBatch?: RepublishLetterBatch;
}

export interface SetPresetLetterPublicationInfoBatchLetterPublicationsParams {
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  orgClusterNodeName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  templateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutDate?: string;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  measurementDate?: string;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalAmountInEuro?: number;
  proposalDate?: string;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  specialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  templateLetterName?: Array<string>;
  setPresetLetterPublicationInfoBatch?: SetPresetLetterPublicationInfoBatch;
}

export interface SetPresetLetterPublicationInfoLetterPublicationsParams {
  id: string;
  setPresetLetterPublicationInfo?: SetPresetLetterPublicationInfo;
}

export interface SetPresetLetterPublicationInfoListLetterPublicationsParams {
  setPresetLetterPublicationInfoList?: SetPresetLetterPublicationInfoList;
}

export interface SignLetterActionsParams {
  letterId: string;
  signLetter?: SignLetter;
}

export interface UnarchiveLetterTemplatesParams {
  id: string;
}

export interface UnpublishLetterLetterPublicationsParams {
  id: string;
  unpublishLetter?: UnpublishLetter;
}

export interface UpdateBatchStatusMailQueueParams {
  batchId: string;
  updateMailQueueBatch?: UpdateMailQueueBatch;
}

export interface UpdateEmailStatusMailQueueParams {
  id: number;
  updateMailQueueEmail?: UpdateMailQueueEmail;
}

export interface UpdateLetterSeenByLettersParams {
  id: string;
  addLetterSeenBy?: AddLetterSeenBy;
}

export interface UpdateLetterTemplatesParams {
  updateTemplate?: UpdateTemplate;
}

export interface UpdateLettersParams {
  id: string;
  updateLetter?: UpdateLetter;
}

export interface UpdateMessageTasksParams {
  id: string;
  updateTaskContent?: UpdateTaskContent;
}

export interface UpdateNewMessageMailsParams {
  id: string;
  updateMailMessage?: UpdateMailMessage;
}

export interface UpdateNewMessageNotificationsParams {
  id: string;
  updateNotificationMessage?: UpdateNotificationMessage;
}

export interface UpdateSeenByWorkflowInstancesParams {
  id: string;
}

export interface UpdateSettingsMailsParams {
  id: string;
  updateMailSettings?: UpdateMailSettings;
}

export interface UpdateSettingsNotificationsParams {
  id: string;
  updateNotificationSettings?: UpdateNotificationSettings;
}

export interface UpdateSettingsTasksParams {
  id: string;
  updateTaskSettings?: UpdateTaskSettings;
}

export interface UpdateTargetGroupTasksParams {
  id: string;
  updateTaskTargetGroup?: UpdateTaskTargetGroup;
}

export interface UpdateTasksParams {
  updateTask?: UpdateTask;
}

export interface UpdateWorkflowTemplatesParams {
  id: string;
  updateWorkflowTemplate?: UpdateWorkflowTemplate;
}

export interface UpdateWorkflowsParams {
  id: string;
  updateWorkflow?: UpdateWorkflow;
}

@Injectable({
  providedIn: 'root'
})
export class CommunicationsService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addRuleSetMails(
    requestParameters?: AddRuleSetMailsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Mail>;
  public addRuleSetMails(
    requestParameters?: AddRuleSetMailsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Mail>>;
  public addRuleSetMails(
    requestParameters?: AddRuleSetMailsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Mail>>;
  public addRuleSetMails(requestParameters?: AddRuleSetMailsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('addRuleSetMails', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/mails/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/rule-set`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMailPopulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addRuleSetNotifications(
    requestParameters?: AddRuleSetNotificationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Notification>;
  public addRuleSetNotifications(
    requestParameters?: AddRuleSetNotificationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Notification>>;
  public addRuleSetNotifications(
    requestParameters?: AddRuleSetNotificationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Notification>>;
  public addRuleSetNotifications(
    requestParameters?: AddRuleSetNotificationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('addRuleSetNotifications', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/notifications/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/rule-set`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.notificationsUpdatePopulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addRuleSetTasks(
    requestParameters?: AddRuleSetTasksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Task>;
  public addRuleSetTasks(
    requestParameters?: AddRuleSetTasksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Task>>;
  public addRuleSetTasks(
    requestParameters?: AddRuleSetTasksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Task>>;
  public addRuleSetTasks(requestParameters?: AddRuleSetTasksParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('addRuleSetTasks', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/tasks/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/rule-set`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateTaskPopulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public archiveLetterTemplates(
    requestParameters?: ArchiveLetterTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<WorkflowTemplate>;
  public archiveLetterTemplates(
    requestParameters?: ArchiveLetterTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<WorkflowTemplate>>;
  public archiveLetterTemplates(
    requestParameters?: ArchiveLetterTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<WorkflowTemplate>>;
  public archiveLetterTemplates(
    requestParameters?: ArchiveLetterTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('archiveLetterTemplates', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/archive`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public archiveMails(
    requestParameters?: ArchiveMailsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Mail>;
  public archiveMails(
    requestParameters?: ArchiveMailsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Mail>>;
  public archiveMails(
    requestParameters?: ArchiveMailsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Mail>>;
  public archiveMails(requestParameters?: ArchiveMailsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('archiveMails', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/mails/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/archive`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public archiveNotifications(
    requestParameters?: ArchiveNotificationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Notification>;
  public archiveNotifications(
    requestParameters?: ArchiveNotificationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Notification>>;
  public archiveNotifications(
    requestParameters?: ArchiveNotificationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Notification>>;
  public archiveNotifications(requestParameters?: ArchiveNotificationsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('archiveNotifications', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/notifications/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/archive`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public archiveTaskTasks(
    requestParameters?: ArchiveTaskTasksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Task>;
  public archiveTaskTasks(
    requestParameters?: ArchiveTaskTasksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Task>>;
  public archiveTaskTasks(
    requestParameters?: ArchiveTaskTasksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Task>>;
  public archiveTaskTasks(requestParameters?: ArchiveTaskTasksParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('archiveTaskTasks', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/tasks/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/archive`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public autoForwardLettersLetterAutoForward(
    requestParameters?: AutoForwardLettersLetterAutoForwardParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public autoForwardLettersLetterAutoForward(
    requestParameters?: AutoForwardLettersLetterAutoForwardParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public autoForwardLettersLetterAutoForward(
    requestParameters?: AutoForwardLettersLetterAutoForwardParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public autoForwardLettersLetterAutoForward(
    requestParameters?: AutoForwardLettersLetterAutoForwardParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/letters/auto-forward`,
      accepts: [],
      body: requestParameters?.autoForwardLetters,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsAutoFinalizeLettersByQueryLetterFinalization(
    requestParameters?: CommunicationsAutoFinalizeLettersByQueryLetterFinalizationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsAutoFinalizeLettersByQueryLetterFinalization(
    requestParameters?: CommunicationsAutoFinalizeLettersByQueryLetterFinalizationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsAutoFinalizeLettersByQueryLetterFinalization(
    requestParameters?: CommunicationsAutoFinalizeLettersByQueryLetterFinalizationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsAutoFinalizeLettersByQueryLetterFinalization(
    requestParameters?: CommunicationsAutoFinalizeLettersByQueryLetterFinalizationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/letters/batch/finalization`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.autoFinalizeLettersByQuery,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsAutoFinalizeLettersLetterFinalization(
    requestParameters?: CommunicationsAutoFinalizeLettersLetterFinalizationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsAutoFinalizeLettersLetterFinalization(
    requestParameters?: CommunicationsAutoFinalizeLettersLetterFinalizationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsAutoFinalizeLettersLetterFinalization(
    requestParameters?: CommunicationsAutoFinalizeLettersLetterFinalizationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsAutoFinalizeLettersLetterFinalization(
    requestParameters?: CommunicationsAutoFinalizeLettersLetterFinalizationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/letters/list/finalization`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.autoFinalizeLetters,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsBatchDownloadByQueryLetters(
    requestParameters?: CommunicationsBatchDownloadByQueryLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsBatchDownloadByQueryLetters(
    requestParameters?: CommunicationsBatchDownloadByQueryLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsBatchDownloadByQueryLetters(
    requestParameters?: CommunicationsBatchDownloadByQueryLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsBatchDownloadByQueryLetters(
    requestParameters?: CommunicationsBatchDownloadByQueryLettersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/letters/batch/download`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.downloadLetters,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsBatchUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsBatchUnpublishLetterLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsBatchUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsBatchUnpublishLetterLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsBatchUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsBatchUnpublishLetterLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsBatchUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsBatchUnpublishLetterLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/batch/unpublish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.unpublishLetterBatch,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsCreateLetterBatchLetters(
    requestParameters?: CommunicationsCreateLetterBatchLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsCreateLetterBatchLetters(
    requestParameters?: CommunicationsCreateLetterBatchLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsCreateLetterBatchLetters(
    requestParameters?: CommunicationsCreateLetterBatchLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsCreateLetterBatchLetters(
    requestParameters?: CommunicationsCreateLetterBatchLettersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/letters/batch`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.createLetterBatch,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsCreateLetters(
    requestParameters?: CommunicationsCreateLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsCreateLetters(
    requestParameters?: CommunicationsCreateLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsCreateLetters(
    requestParameters?: CommunicationsCreateLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsCreateLetters(
    requestParameters?: CommunicationsCreateLettersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/letters`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createLetter,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsCreateMails(
    requestParameters?: CommunicationsCreateMailsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Mail>;
  public communicationsCreateMails(
    requestParameters?: CommunicationsCreateMailsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Mail>>;
  public communicationsCreateMails(
    requestParameters?: CommunicationsCreateMailsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Mail>>;
  public communicationsCreateMails(
    requestParameters?: CommunicationsCreateMailsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/communications/mails`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createMail,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsCreateManyLetters(
    requestParameters?: CommunicationsCreateManyLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsCreateManyLetters(
    requestParameters?: CommunicationsCreateManyLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsCreateManyLetters(
    requestParameters?: CommunicationsCreateManyLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsCreateManyLetters(
    requestParameters?: CommunicationsCreateManyLettersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/letters/list`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createLetterBulk,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsListUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsListUnpublishLetterLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsListUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsListUnpublishLetterLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsListUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsListUnpublishLetterLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsListUnpublishLetterLetterPublications(
    requestParameters?: CommunicationsListUnpublishLetterLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/list/unpublish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.unpublishLetterList,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsPublishLetterBatchLetterPublications(
    requestParameters?: CommunicationsPublishLetterBatchLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsPublishLetterBatchLetterPublications(
    requestParameters?: CommunicationsPublishLetterBatchLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPublishLetterBatchLetterPublications(
    requestParameters?: CommunicationsPublishLetterBatchLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPublishLetterBatchLetterPublications(
    requestParameters?: CommunicationsPublishLetterBatchLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/batch/publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.publishLetterBatch,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsPublishLetterListLetterPublications(
    requestParameters?: CommunicationsPublishLetterListLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public communicationsPublishLetterListLetterPublications(
    requestParameters?: CommunicationsPublishLetterListLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPublishLetterListLetterPublications(
    requestParameters?: CommunicationsPublishLetterListLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public communicationsPublishLetterListLetterPublications(
    requestParameters?: CommunicationsPublishLetterListLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/list/publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.publishLetterList,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public communicationsQueryLetterTemplates(
    requestParameters?: CommunicationsQueryLetterTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfWorkflowTemplate>;
  public communicationsQueryLetterTemplates(
    requestParameters?: CommunicationsQueryLetterTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfWorkflowTemplate>>;
  public communicationsQueryLetterTemplates(
    requestParameters?: CommunicationsQueryLetterTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfWorkflowTemplate>>;
  public communicationsQueryLetterTemplates(
    requestParameters?: CommunicationsQueryLetterTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/letters/templates`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Title': requestParameters?.queryTitle,
        'Query.Description': requestParameters?.queryDescription,
        'Query.LetterType': requestParameters?.queryLetterType,
        'Query.State': requestParameters?.queryState,
        'Query.CreatedBy': requestParameters?.queryCreatedBy,
        'Query.UpdatedBy': requestParameters?.queryUpdatedBy,
        'Query.CreatedAt': requestParameters?.queryCreatedAt,
        'Query.UpdatedAt': requestParameters?.queryUpdatedAt,
        'Query.CreatedAtFrom': requestParameters?.queryCreatedAtFrom,
        'Query.CreatedAtTo': requestParameters?.queryCreatedAtTo,
        'Query.UpdatedAtFrom': requestParameters?.queryUpdatedAtFrom,
        'Query.UpdatedAtTo': requestParameters?.queryUpdatedAtTo,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createLabels(
    requestParameters?: CreateLabelsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Label>;
  public createLabels(
    requestParameters?: CreateLabelsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Label>>;
  public createLabels(
    requestParameters?: CreateLabelsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Label>>;
  public createLabels(requestParameters?: CreateLabelsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/communications/labels`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createLabel,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createLetterBatchDryLetters(
    requestParameters?: CreateLetterBatchDryLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public createLetterBatchDryLetters(
    requestParameters?: CreateLetterBatchDryLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public createLetterBatchDryLetters(
    requestParameters?: CreateLetterBatchDryLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public createLetterBatchDryLetters(
    requestParameters?: CreateLetterBatchDryLettersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/letters/dry`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.createDryLetterBatch,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createLetterComments(
    requestParameters?: CreateLetterCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public createLetterComments(
    requestParameters?: CreateLetterCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public createLetterComments(
    requestParameters?: CreateLetterCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public createLetterComments(requestParameters?: CreateLetterCommentsParams, ...args: RequestArgs): Observable<any> {
    const letterId = requestParameters?.letterId;
    this.checkRequired('createLetterComments', { letterId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/letters/${this.configuration.encodeParam({ name: 'letterId', value: letterId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: [],
      body: requestParameters?.createLetterComment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createLetterTemplates(
    requestParameters?: CreateLetterTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<WorkflowTemplate>;
  public createLetterTemplates(
    requestParameters?: CreateLetterTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<WorkflowTemplate>>;
  public createLetterTemplates(
    requestParameters?: CreateLetterTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<WorkflowTemplate>>;
  public createLetterTemplates(requestParameters?: CreateLetterTemplatesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/letters/templates`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.letterTemplatesCreateTemplate,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createNotifications(
    requestParameters?: CreateNotificationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Notification>;
  public createNotifications(
    requestParameters?: CreateNotificationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Notification>>;
  public createNotifications(
    requestParameters?: CreateNotificationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Notification>>;
  public createNotifications(requestParameters?: CreateNotificationsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/communications/notifications`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createNotification,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createTasks(
    requestParameters?: CreateTasksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Task>;
  public createTasks(
    requestParameters?: CreateTasksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Task>>;
  public createTasks(
    requestParameters?: CreateTasksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Task>>;
  public createTasks(requestParameters?: CreateTasksParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/communications/tasks`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createTask,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createWorkflowInstanceComments(
    requestParameters?: CreateWorkflowInstanceCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public createWorkflowInstanceComments(
    requestParameters?: CreateWorkflowInstanceCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public createWorkflowInstanceComments(
    requestParameters?: CreateWorkflowInstanceCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public createWorkflowInstanceComments(
    requestParameters?: CreateWorkflowInstanceCommentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const workflowInstanceId = requestParameters?.workflowInstanceId;
    this.checkRequired('createWorkflowInstanceComments', { workflowInstanceId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/workflow-instance/${this.configuration.encodeParam({ name: 'workflowInstanceId', value: workflowInstanceId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createWorkflowInstanceComment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createWorkflowTemplates(
    requestParameters?: CreateWorkflowTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<WorkflowTemplate>;
  public createWorkflowTemplates(
    requestParameters?: CreateWorkflowTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<WorkflowTemplate>>;
  public createWorkflowTemplates(
    requestParameters?: CreateWorkflowTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<WorkflowTemplate>>;
  public createWorkflowTemplates(
    requestParameters?: CreateWorkflowTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/letters/workflows/templates`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createWorkflowTemplate,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteLetterTemplates(
    requestParameters?: DeleteLetterTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public deleteLetterTemplates(
    requestParameters?: DeleteLetterTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public deleteLetterTemplates(
    requestParameters?: DeleteLetterTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public deleteLetterTemplates(requestParameters?: DeleteLetterTemplatesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteLetterTemplates', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/master/letters/templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteManyBySeasonLetters(
    requestParameters?: DeleteManyBySeasonLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<LetterBatchMetadataModel>;
  public deleteManyBySeasonLetters(
    requestParameters?: DeleteManyBySeasonLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<LetterBatchMetadataModel>>;
  public deleteManyBySeasonLetters(
    requestParameters?: DeleteManyBySeasonLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<LetterBatchMetadataModel>>;
  public deleteManyBySeasonLetters(
    requestParameters?: DeleteManyBySeasonLettersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('deleteManyBySeasonLetters', { seasonId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/master/letters/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId2,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteManyLetters(
    requestParameters?: DeleteManyLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<LetterBatchMetadataModel>;
  public deleteManyLetters(
    requestParameters?: DeleteManyLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<LetterBatchMetadataModel>>;
  public deleteManyLetters(
    requestParameters?: DeleteManyLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<LetterBatchMetadataModel>>;
  public deleteManyLetters(requestParameters?: DeleteManyLettersParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/master/letters`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.deleteLetterList,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteWorkflowTemplates(
    requestParameters?: DeleteWorkflowTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteWorkflowTemplates(
    requestParameters?: DeleteWorkflowTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteWorkflowTemplates(
    requestParameters?: DeleteWorkflowTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteWorkflowTemplates(
    requestParameters?: DeleteWorkflowTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteWorkflowTemplates', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/master/letters/workflows/templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public forwardLetterActions(
    requestParameters?: ForwardLetterActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public forwardLetterActions(
    requestParameters?: ForwardLetterActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public forwardLetterActions(
    requestParameters?: ForwardLetterActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public forwardLetterActions(requestParameters?: ForwardLetterActionsParams, ...args: RequestArgs): Observable<any> {
    const letterId = requestParameters?.letterId;
    this.checkRequired('forwardLetterActions', { letterId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/${this.configuration.encodeParam({ name: 'letterId', value: letterId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/forward`,
      accepts: [],
      body: requestParameters?.forwardLetter,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDetailsMailQueue(
    requestParameters?: GetDetailsMailQueueParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmailDetail>;
  public getDetailsMailQueue(
    requestParameters?: GetDetailsMailQueueParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmailDetail>>;
  public getDetailsMailQueue(
    requestParameters?: GetDetailsMailQueueParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmailDetail>>;
  public getDetailsMailQueue(requestParameters?: GetDetailsMailQueueParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getDetailsMailQueue', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/emails/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getLabels(
    requestParameters?: GetLabelsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Label>;
  public getLabels(
    requestParameters?: GetLabelsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Label>>;
  public getLabels(
    requestParameters?: GetLabelsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Label>>;
  public getLabels(requestParameters?: GetLabelsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getLabels', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/communications/labels/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getLetterTemplates(
    requestParameters?: GetLetterTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<WorkflowTemplate>;
  public getLetterTemplates(
    requestParameters?: GetLetterTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<WorkflowTemplate>>;
  public getLetterTemplates(
    requestParameters?: GetLetterTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<WorkflowTemplate>>;
  public getLetterTemplates(requestParameters?: GetLetterTemplatesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getLetterTemplates', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/letters/templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getLetters(
    requestParameters?: GetLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CommunicationsLettersLetter>;
  public getLetters(
    requestParameters?: GetLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CommunicationsLettersLetter>>;
  public getLetters(
    requestParameters?: GetLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CommunicationsLettersLetter>>;
  public getLetters(requestParameters?: GetLettersParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getLetters', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/letters/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMails(
    requestParameters?: GetMailsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Mail>;
  public getMails(
    requestParameters?: GetMailsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Mail>>;
  public getMails(
    requestParameters?: GetMailsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Mail>>;
  public getMails(requestParameters?: GetMailsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getMails', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/communications/mails/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getNotifications(
    requestParameters?: GetNotificationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Notification>;
  public getNotifications(
    requestParameters?: GetNotificationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Notification>>;
  public getNotifications(
    requestParameters?: GetNotificationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Notification>>;
  public getNotifications(requestParameters?: GetNotificationsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getNotifications', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/communications/notifications/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPresetLetterPublicationInfoLetterPublications(
    requestParameters?: GetPresetLetterPublicationInfoLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPresetLetterPublicationInfo>;
  public getPresetLetterPublicationInfoLetterPublications(
    requestParameters?: GetPresetLetterPublicationInfoLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPresetLetterPublicationInfo>>;
  public getPresetLetterPublicationInfoLetterPublications(
    requestParameters?: GetPresetLetterPublicationInfoLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPresetLetterPublicationInfo>>;
  public getPresetLetterPublicationInfoLetterPublications(
    requestParameters?: GetPresetLetterPublicationInfoLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/letters/batch/preset`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        seasonId: requestParameters?.seasonId,
        letterType: requestParameters?.letterType,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTasks(
    requestParameters?: GetTasksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Task>;
  public getTasks(
    requestParameters?: GetTasksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Task>>;
  public getTasks(
    requestParameters?: GetTasksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Task>>;
  public getTasks(requestParameters?: GetTasksParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getTasks', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/communications/tasks/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTasksByEmployeeIdTasks(
    requestParameters?: GetTasksByEmployeeIdTasksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<Task>>;
  public getTasksByEmployeeIdTasks(
    requestParameters?: GetTasksByEmployeeIdTasksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<Task>>>;
  public getTasksByEmployeeIdTasks(
    requestParameters?: GetTasksByEmployeeIdTasksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<Task>>>;
  public getTasksByEmployeeIdTasks(
    requestParameters?: GetTasksByEmployeeIdTasksParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getTasksByEmployeeIdTasks', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/communications/tasks/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getWorkflowTemplates(
    requestParameters?: GetWorkflowTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<WorkflowTemplate>;
  public getWorkflowTemplates(
    requestParameters?: GetWorkflowTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<WorkflowTemplate>>;
  public getWorkflowTemplates(
    requestParameters?: GetWorkflowTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<WorkflowTemplate>>;
  public getWorkflowTemplates(requestParameters?: GetWorkflowTemplatesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getWorkflowTemplates', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/letters/workflows/templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public publishLetterActions(
    requestParameters?: PublishLetterActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public publishLetterActions(
    requestParameters?: PublishLetterActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public publishLetterActions(
    requestParameters?: PublishLetterActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public publishLetterActions(requestParameters?: PublishLetterActionsParams, ...args: RequestArgs): Observable<any> {
    const letterId = requestParameters?.letterId;
    this.checkRequired('publishLetterActions', { letterId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/${this.configuration.encodeParam({ name: 'letterId', value: letterId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/confirm`,
      accepts: [],
      body: requestParameters?.confirmLetter,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public publishLetterLetterPublications(
    requestParameters?: PublishLetterLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public publishLetterLetterPublications(
    requestParameters?: PublishLetterLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public publishLetterLetterPublications(
    requestParameters?: PublishLetterLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public publishLetterLetterPublications(
    requestParameters?: PublishLetterLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('publishLetterLetterPublications', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.publishLetter,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public publishMails(
    requestParameters?: PublishMailsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPublishingMetadata>;
  public publishMails(
    requestParameters?: PublishMailsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPublishingMetadata>>;
  public publishMails(
    requestParameters?: PublishMailsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPublishingMetadata>>;
  public publishMails(requestParameters?: PublishMailsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('publishMails', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/mails/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publish`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public publishNotifications(
    requestParameters?: PublishNotificationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPublishingMetadata>;
  public publishNotifications(
    requestParameters?: PublishNotificationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPublishingMetadata>>;
  public publishNotifications(
    requestParameters?: PublishNotificationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPublishingMetadata>>;
  public publishNotifications(requestParameters?: PublishNotificationsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('publishNotifications', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/notifications/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publish`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public publishPresetLetterBatchLetterPublications(
    requestParameters?: PublishPresetLetterBatchLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public publishPresetLetterBatchLetterPublications(
    requestParameters?: PublishPresetLetterBatchLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public publishPresetLetterBatchLetterPublications(
    requestParameters?: PublishPresetLetterBatchLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public publishPresetLetterBatchLetterPublications(
    requestParameters?: PublishPresetLetterBatchLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/letters/batch/preset/publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.publishPresetLetterBatch,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public publishPresetLetterListLetterPublications(
    requestParameters?: PublishPresetLetterListLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public publishPresetLetterListLetterPublications(
    requestParameters?: PublishPresetLetterListLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public publishPresetLetterListLetterPublications(
    requestParameters?: PublishPresetLetterListLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public publishPresetLetterListLetterPublications(
    requestParameters?: PublishPresetLetterListLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/letters/list/preset/publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.publishPresetLetterList,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public publishTaskTasks(
    requestParameters?: PublishTaskTasksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPublishingMetadata>;
  public publishTaskTasks(
    requestParameters?: PublishTaskTasksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPublishingMetadata>>;
  public publishTaskTasks(
    requestParameters?: PublishTaskTasksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPublishingMetadata>>;
  public publishTaskTasks(requestParameters?: PublishTaskTasksParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('publishTaskTasks', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/tasks/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publish`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryBatchesMailQueue(
    requestParameters?: QueryBatchesMailQueueParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmailBatch>;
  public queryBatchesMailQueue(
    requestParameters?: QueryBatchesMailQueueParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmailBatch>>;
  public queryBatchesMailQueue(
    requestParameters?: QueryBatchesMailQueueParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmailBatch>>;
  public queryBatchesMailQueue(requestParameters?: QueryBatchesMailQueueParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/emails/batch`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Author: requestParameters?.author,
        Subject: requestParameters?.subject,
        AuthorGid: requestParameters?.authorGid,
        Recipient: requestParameters?.recipient,
        Sender: requestParameters?.sender,
        Status: requestParameters?.status,
        Type: requestParameters?.type,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryByEmployeeLetters(
    requestParameters?: QueryByEmployeeLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<CommunicationsLettersLetter>>;
  public queryByEmployeeLetters(
    requestParameters?: QueryByEmployeeLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<CommunicationsLettersLetter>>>;
  public queryByEmployeeLetters(
    requestParameters?: QueryByEmployeeLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<CommunicationsLettersLetter>>>;
  public queryByEmployeeLetters(
    requestParameters?: QueryByEmployeeLettersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('queryByEmployeeLetters', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/letters/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryByWorkflowWorkflowTemplates(
    requestParameters?: QueryByWorkflowWorkflowTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfWorkflowTemplate>;
  public queryByWorkflowWorkflowTemplates(
    requestParameters?: QueryByWorkflowWorkflowTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfWorkflowTemplate>>;
  public queryByWorkflowWorkflowTemplates(
    requestParameters?: QueryByWorkflowWorkflowTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfWorkflowTemplate>>;
  public queryByWorkflowWorkflowTemplates(
    requestParameters?: QueryByWorkflowWorkflowTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const workflowId = requestParameters?.workflowId;
    this.checkRequired('queryByWorkflowWorkflowTemplates', { workflowId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/letters/workflows/${this.configuration.encodeParam({ name: 'workflowId', value: workflowId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/templates`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Type: requestParameters?.type,
        State: requestParameters?.state,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryCommunications(
    requestParameters?: QueryCommunicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfCommunication>;
  public queryCommunications(
    requestParameters?: QueryCommunicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfCommunication>>;
  public queryCommunications(
    requestParameters?: QueryCommunicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfCommunication>>;
  public queryCommunications(requestParameters?: QueryCommunicationsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/communications`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.Language': requestParameters?.queryLanguage,
        'Query.Title': requestParameters?.queryTitle,
        'Query.Description': requestParameters?.queryDescription,
        'Query.State': requestParameters?.queryState,
        'Query.Type': requestParameters?.queryType,
        'Query.Label': requestParameters?.queryLabel,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.Fullname': requestParameters?.queryFullname,
        'Query.PublicationDate': requestParameters?.queryPublicationDate,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesCommunications(
    requestParameters?: QueryFieldValuesCommunicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValuesCommunications(
    requestParameters?: QueryFieldValuesCommunicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValuesCommunications(
    requestParameters?: QueryFieldValuesCommunicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValuesCommunications(
    requestParameters?: QueryFieldValuesCommunicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/communications/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        TargetProperty: requestParameters?.targetProperty,
        SeasonId: requestParameters?.seasonId,
        Language: requestParameters?.language,
        Title: requestParameters?.title,
        Description: requestParameters?.description,
        State: requestParameters?.state,
        Type: requestParameters?.type,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        Label: requestParameters?.label
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryLabels(
    requestParameters?: QueryLabelsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<Label>>;
  public queryLabels(
    requestParameters?: QueryLabelsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<Label>>>;
  public queryLabels(
    requestParameters?: QueryLabelsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<Label>>>;
  public queryLabels(requestParameters?: QueryLabelsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/communications/labels`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Name: requestParameters?.name }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryLetterComments(
    requestParameters?: QueryLetterCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<LetterComment>>;
  public queryLetterComments(
    requestParameters?: QueryLetterCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<LetterComment>>>;
  public queryLetterComments(
    requestParameters?: QueryLetterCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<LetterComment>>>;
  public queryLetterComments(requestParameters?: QueryLetterCommentsParams, ...args: RequestArgs): Observable<any> {
    const letterId = requestParameters?.letterId;
    this.checkRequired('queryLetterComments', { letterId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/letters/${this.configuration.encodeParam({ name: 'letterId', value: letterId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryLetters(
    requestParameters?: QueryLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<CommunicationsLettersLetter>>;
  public queryLetters(
    requestParameters?: QueryLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<CommunicationsLettersLetter>>>;
  public queryLetters(
    requestParameters?: QueryLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<CommunicationsLettersLetter>>>;
  public queryLetters(requestParameters?: QueryLettersParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/letters`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        ReceiverId: requestParameters?.receiverId,
        ManagerId: requestParameters?.managerId,
        BusinessPartnerId: requestParameters?.businessPartnerId,
        SeasonId: requestParameters?.seasonId,
        IsAdmin: requestParameters?.isAdmin
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMailsByBatchIdMailQueue(
    requestParameters?: QueryMailsByBatchIdMailQueueParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmailPreview>;
  public queryMailsByBatchIdMailQueue(
    requestParameters?: QueryMailsByBatchIdMailQueueParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmailPreview>>;
  public queryMailsByBatchIdMailQueue(
    requestParameters?: QueryMailsByBatchIdMailQueueParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmailPreview>>;
  public queryMailsByBatchIdMailQueue(
    requestParameters?: QueryMailsByBatchIdMailQueueParams,
    ...args: RequestArgs
  ): Observable<any> {
    const batchId = requestParameters?.batchId;
    this.checkRequired('queryMailsByBatchIdMailQueue', { batchId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/emails/batch/${this.configuration.encodeParam({ name: 'batchId', value: batchId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        Author: requestParameters?.author,
        Subject: requestParameters?.subject,
        AuthorGid: requestParameters?.authorGid,
        Recipient: requestParameters?.recipient,
        Sender: requestParameters?.sender,
        Status: requestParameters?.status,
        Type: requestParameters?.type
      }
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPlaceholdersLetterTemplates(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public queryPlaceholdersLetterTemplates(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public queryPlaceholdersLetterTemplates(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public queryPlaceholdersLetterTemplates(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/letters/templates/placeholder`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryWorkflowInstanceComments(
    requestParameters?: QueryWorkflowInstanceCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<WorkflowInstanceComment>>;
  public queryWorkflowInstanceComments(
    requestParameters?: QueryWorkflowInstanceCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<WorkflowInstanceComment>>>;
  public queryWorkflowInstanceComments(
    requestParameters?: QueryWorkflowInstanceCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<WorkflowInstanceComment>>>;
  public queryWorkflowInstanceComments(
    requestParameters?: QueryWorkflowInstanceCommentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const workflowInstanceId = requestParameters?.workflowInstanceId;
    this.checkRequired('queryWorkflowInstanceComments', { workflowInstanceId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/workflow-instance/${this.configuration.encodeParam({ name: 'workflowInstanceId', value: workflowInstanceId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryWorkflowTemplates(
    requestParameters?: QueryWorkflowTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfWorkflowTemplate>;
  public queryWorkflowTemplates(
    requestParameters?: QueryWorkflowTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfWorkflowTemplate>>;
  public queryWorkflowTemplates(
    requestParameters?: QueryWorkflowTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfWorkflowTemplate>>;
  public queryWorkflowTemplates(
    requestParameters?: QueryWorkflowTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/letters/workflows/templates`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Type: requestParameters?.type,
        State: requestParameters?.state,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryWorkflows(
    requestParameters?: QueryWorkflowsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfWorkflow>;
  public queryWorkflows(
    requestParameters?: QueryWorkflowsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfWorkflow>>;
  public queryWorkflows(
    requestParameters?: QueryWorkflowsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfWorkflow>>;
  public queryWorkflows(requestParameters?: QueryWorkflowsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/letters/workflows`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Category: requestParameters?.category, Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public rejectLetterActions(
    requestParameters?: RejectLetterActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public rejectLetterActions(
    requestParameters?: RejectLetterActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public rejectLetterActions(
    requestParameters?: RejectLetterActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public rejectLetterActions(requestParameters?: RejectLetterActionsParams, ...args: RequestArgs): Observable<any> {
    const letterId = requestParameters?.letterId;
    this.checkRequired('rejectLetterActions', { letterId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/${this.configuration.encodeParam({ name: 'letterId', value: letterId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/reject`,
      accepts: [],
      body: requestParameters?.rejectLetter,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public removeLabelsMails(
    requestParameters?: RemoveLabelsMailsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Mail>;
  public removeLabelsMails(
    requestParameters?: RemoveLabelsMailsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Mail>>;
  public removeLabelsMails(
    requestParameters?: RemoveLabelsMailsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Mail>>;
  public removeLabelsMails(requestParameters?: RemoveLabelsMailsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('removeLabelsMails', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/master/communications/mails/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/labels`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.mailsRemoveManyLabels,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public removeLabelsNotifications(
    requestParameters?: RemoveLabelsNotificationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Notification>;
  public removeLabelsNotifications(
    requestParameters?: RemoveLabelsNotificationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Notification>>;
  public removeLabelsNotifications(
    requestParameters?: RemoveLabelsNotificationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Notification>>;
  public removeLabelsNotifications(
    requestParameters?: RemoveLabelsNotificationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('removeLabelsNotifications', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/master/communications/notifications/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/labels`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.notificationsRemoveManyLabels,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public removeLabelsTasks(
    requestParameters?: RemoveLabelsTasksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Task>;
  public removeLabelsTasks(
    requestParameters?: RemoveLabelsTasksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Task>>;
  public removeLabelsTasks(
    requestParameters?: RemoveLabelsTasksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Task>>;
  public removeLabelsTasks(requestParameters?: RemoveLabelsTasksParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('removeLabelsTasks', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/master/communications/tasks/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/labels`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.removeManyTaskLabels,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public republishLetterBatchLetterPublications(
    requestParameters?: RepublishLetterBatchLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public republishLetterBatchLetterPublications(
    requestParameters?: RepublishLetterBatchLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public republishLetterBatchLetterPublications(
    requestParameters?: RepublishLetterBatchLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public republishLetterBatchLetterPublications(
    requestParameters?: RepublishLetterBatchLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/batch/republish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.republishLetterBatch,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public setPresetLetterPublicationInfoBatchLetterPublications(
    requestParameters?: SetPresetLetterPublicationInfoBatchLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public setPresetLetterPublicationInfoBatchLetterPublications(
    requestParameters?: SetPresetLetterPublicationInfoBatchLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public setPresetLetterPublicationInfoBatchLetterPublications(
    requestParameters?: SetPresetLetterPublicationInfoBatchLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public setPresetLetterPublicationInfoBatchLetterPublications(
    requestParameters?: SetPresetLetterPublicationInfoBatchLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/master/letters/batch/preset`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        OrgClusterNodeName: requestParameters?.orgClusterNodeName,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        TemplateType: requestParameters?.templateType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutDate: requestParameters?.payoutDate,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        MeasurementDate: requestParameters?.measurementDate,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalAmountInEuro: requestParameters?.proposalAmountInEuro,
        ProposalDate: requestParameters?.proposalDate,
        ProposalState: requestParameters?.proposalState,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        SpecialPaymentCompensationType: requestParameters?.specialPaymentCompensationType,
        TemplateLetterName: requestParameters?.templateLetterName
      },
      body: requestParameters?.setPresetLetterPublicationInfoBatch,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public setPresetLetterPublicationInfoLetterPublications(
    requestParameters?: SetPresetLetterPublicationInfoLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public setPresetLetterPublicationInfoLetterPublications(
    requestParameters?: SetPresetLetterPublicationInfoLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public setPresetLetterPublicationInfoLetterPublications(
    requestParameters?: SetPresetLetterPublicationInfoLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public setPresetLetterPublicationInfoLetterPublications(
    requestParameters?: SetPresetLetterPublicationInfoLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('setPresetLetterPublicationInfoLetterPublications', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/master/letters/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/preset`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.setPresetLetterPublicationInfo,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public setPresetLetterPublicationInfoListLetterPublications(
    requestParameters?: SetPresetLetterPublicationInfoListLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public setPresetLetterPublicationInfoListLetterPublications(
    requestParameters?: SetPresetLetterPublicationInfoListLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public setPresetLetterPublicationInfoListLetterPublications(
    requestParameters?: SetPresetLetterPublicationInfoListLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public setPresetLetterPublicationInfoListLetterPublications(
    requestParameters?: SetPresetLetterPublicationInfoListLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/master/letters/list/preset`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.setPresetLetterPublicationInfoList,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public signLetterActions(
    requestParameters?: SignLetterActionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public signLetterActions(
    requestParameters?: SignLetterActionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public signLetterActions(
    requestParameters?: SignLetterActionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public signLetterActions(requestParameters?: SignLetterActionsParams, ...args: RequestArgs): Observable<any> {
    const letterId = requestParameters?.letterId;
    this.checkRequired('signLetterActions', { letterId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/${this.configuration.encodeParam({ name: 'letterId', value: letterId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/sign`,
      accepts: [],
      body: requestParameters?.signLetter,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public unarchiveLetterTemplates(
    requestParameters?: UnarchiveLetterTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<WorkflowTemplate>;
  public unarchiveLetterTemplates(
    requestParameters?: UnarchiveLetterTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<WorkflowTemplate>>;
  public unarchiveLetterTemplates(
    requestParameters?: UnarchiveLetterTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<WorkflowTemplate>>;
  public unarchiveLetterTemplates(
    requestParameters?: UnarchiveLetterTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('unarchiveLetterTemplates', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/unarchive`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public unpublishLetterLetterPublications(
    requestParameters?: UnpublishLetterLetterPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfLetterBatchMetadata>;
  public unpublishLetterLetterPublications(
    requestParameters?: UnpublishLetterLetterPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfLetterBatchMetadata>>;
  public unpublishLetterLetterPublications(
    requestParameters?: UnpublishLetterLetterPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfLetterBatchMetadata>>;
  public unpublishLetterLetterPublications(
    requestParameters?: UnpublishLetterLetterPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('unpublishLetterLetterPublications', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/unpublish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.unpublishLetter,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBatchStatusMailQueue(
    requestParameters?: UpdateBatchStatusMailQueueParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmailBatch>;
  public updateBatchStatusMailQueue(
    requestParameters?: UpdateBatchStatusMailQueueParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmailBatch>>;
  public updateBatchStatusMailQueue(
    requestParameters?: UpdateBatchStatusMailQueueParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmailBatch>>;
  public updateBatchStatusMailQueue(
    requestParameters?: UpdateBatchStatusMailQueueParams,
    ...args: RequestArgs
  ): Observable<any> {
    const batchId = requestParameters?.batchId;
    this.checkRequired('updateBatchStatusMailQueue', { batchId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/emails/batch/${this.configuration.encodeParam({ name: 'batchId', value: batchId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMailQueueBatch,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmailStatusMailQueue(
    requestParameters?: UpdateEmailStatusMailQueueParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmailDetail>;
  public updateEmailStatusMailQueue(
    requestParameters?: UpdateEmailStatusMailQueueParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmailDetail>>;
  public updateEmailStatusMailQueue(
    requestParameters?: UpdateEmailStatusMailQueueParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmailDetail>>;
  public updateEmailStatusMailQueue(
    requestParameters?: UpdateEmailStatusMailQueueParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateEmailStatusMailQueue', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/emails/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMailQueueEmail,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateLetterSeenByLetters(
    requestParameters?: UpdateLetterSeenByLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public updateLetterSeenByLetters(
    requestParameters?: UpdateLetterSeenByLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public updateLetterSeenByLetters(
    requestParameters?: UpdateLetterSeenByLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public updateLetterSeenByLetters(
    requestParameters?: UpdateLetterSeenByLettersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateLetterSeenByLetters', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/seen`,
      accepts: [],
      body: requestParameters?.addLetterSeenBy,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateLetterTemplates(
    requestParameters?: UpdateLetterTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<WorkflowTemplate>;
  public updateLetterTemplates(
    requestParameters?: UpdateLetterTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<WorkflowTemplate>>;
  public updateLetterTemplates(
    requestParameters?: UpdateLetterTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<WorkflowTemplate>>;
  public updateLetterTemplates(requestParameters?: UpdateLetterTemplatesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/templates`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateTemplate,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateLetters(
    requestParameters?: UpdateLettersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public updateLetters(
    requestParameters?: UpdateLettersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public updateLetters(
    requestParameters?: UpdateLettersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public updateLetters(requestParameters?: UpdateLettersParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateLetters', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: [],
      body: requestParameters?.updateLetter,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMessageTasks(
    requestParameters?: UpdateMessageTasksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Task>;
  public updateMessageTasks(
    requestParameters?: UpdateMessageTasksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Task>>;
  public updateMessageTasks(
    requestParameters?: UpdateMessageTasksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Task>>;
  public updateMessageTasks(requestParameters?: UpdateMessageTasksParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateMessageTasks', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/tasks/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/message`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateTaskContent,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateNewMessageMails(
    requestParameters?: UpdateNewMessageMailsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Mail>;
  public updateNewMessageMails(
    requestParameters?: UpdateNewMessageMailsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Mail>>;
  public updateNewMessageMails(
    requestParameters?: UpdateNewMessageMailsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Mail>>;
  public updateNewMessageMails(requestParameters?: UpdateNewMessageMailsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateNewMessageMails', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/mails/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/message`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMailMessage,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateNewMessageNotifications(
    requestParameters?: UpdateNewMessageNotificationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Notification>;
  public updateNewMessageNotifications(
    requestParameters?: UpdateNewMessageNotificationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Notification>>;
  public updateNewMessageNotifications(
    requestParameters?: UpdateNewMessageNotificationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Notification>>;
  public updateNewMessageNotifications(
    requestParameters?: UpdateNewMessageNotificationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateNewMessageNotifications', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/notifications/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/message`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateNotificationMessage,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSeenByWorkflowInstances(
    requestParameters?: UpdateSeenByWorkflowInstancesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public updateSeenByWorkflowInstances(
    requestParameters?: UpdateSeenByWorkflowInstancesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public updateSeenByWorkflowInstances(
    requestParameters?: UpdateSeenByWorkflowInstancesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public updateSeenByWorkflowInstances(
    requestParameters?: UpdateSeenByWorkflowInstancesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateSeenByWorkflowInstances', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/workflow-instance/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/seen`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSettingsMails(
    requestParameters?: UpdateSettingsMailsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Mail>;
  public updateSettingsMails(
    requestParameters?: UpdateSettingsMailsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Mail>>;
  public updateSettingsMails(
    requestParameters?: UpdateSettingsMailsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Mail>>;
  public updateSettingsMails(requestParameters?: UpdateSettingsMailsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateSettingsMails', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/mails/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMailSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSettingsNotifications(
    requestParameters?: UpdateSettingsNotificationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Notification>;
  public updateSettingsNotifications(
    requestParameters?: UpdateSettingsNotificationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Notification>>;
  public updateSettingsNotifications(
    requestParameters?: UpdateSettingsNotificationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Notification>>;
  public updateSettingsNotifications(
    requestParameters?: UpdateSettingsNotificationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateSettingsNotifications', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/notifications/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateNotificationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSettingsTasks(
    requestParameters?: UpdateSettingsTasksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Task>;
  public updateSettingsTasks(
    requestParameters?: UpdateSettingsTasksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Task>>;
  public updateSettingsTasks(
    requestParameters?: UpdateSettingsTasksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Task>>;
  public updateSettingsTasks(requestParameters?: UpdateSettingsTasksParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateSettingsTasks', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/tasks/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateTaskSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateTargetGroupTasks(
    requestParameters?: UpdateTargetGroupTasksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Task>;
  public updateTargetGroupTasks(
    requestParameters?: UpdateTargetGroupTasksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Task>>;
  public updateTargetGroupTasks(
    requestParameters?: UpdateTargetGroupTasksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Task>>;
  public updateTargetGroupTasks(
    requestParameters?: UpdateTargetGroupTasksParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateTargetGroupTasks', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/tasks/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/target-group`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateTaskTargetGroup,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateTasks(
    requestParameters?: UpdateTasksParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Task>;
  public updateTasks(
    requestParameters?: UpdateTasksParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Task>>;
  public updateTasks(
    requestParameters?: UpdateTasksParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Task>>;
  public updateTasks(requestParameters?: UpdateTasksParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/communications/tasks`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateTask,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateWorkflowTemplates(
    requestParameters?: UpdateWorkflowTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<WorkflowTemplate>;
  public updateWorkflowTemplates(
    requestParameters?: UpdateWorkflowTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<WorkflowTemplate>>;
  public updateWorkflowTemplates(
    requestParameters?: UpdateWorkflowTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<WorkflowTemplate>>;
  public updateWorkflowTemplates(
    requestParameters?: UpdateWorkflowTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateWorkflowTemplates', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/workflows/templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateWorkflowTemplate,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateWorkflows(
    requestParameters?: UpdateWorkflowsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Workflow>;
  public updateWorkflows(
    requestParameters?: UpdateWorkflowsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Workflow>>;
  public updateWorkflows(
    requestParameters?: UpdateWorkflowsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Workflow>>;
  public updateWorkflows(requestParameters?: UpdateWorkflowsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateWorkflows', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/letters/workflows/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateWorkflow,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
